import { Component, Input } from '@angular/core';

enum iconSize {
  extraSmall,
  small,
  regular
}

@Component({
  selector: 'app-alert-icon',
  templateUrl: './alert-icon.component.html',
  styleUrls: ['./alert-icon.component.css']
})
export class AlertIconComponent {

  @Input() size: iconSize = iconSize.regular;
  // Fill color for the alert triangle. Defaults to the standard warning yellow;
  // pass the danger red (#D0021B) to flag missing required documents (PRO-1263).
  @Input() colorHex = '#EAA800';

  iconSize = iconSize;

  constructor() {}

}
